// src/components/ExercisePicker.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useDebounce from '../hooks/useDebounce';
import { IoSearch } from 'react-icons/io5';

const ExercisePicker = ({ onSelectExercise, onClose }) => {
  const [exercises, setExercises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const fetchExercises = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      try {
        const params = { search: debouncedSearchTerm };
        const response = await axios.get('http://127.0.0.1:8000/admin/exercises', {
          headers: { Authorization: `Bearer ${token}` },
          params,
        });
        setExercises(response.data);
      } catch (error) {
        console.error("Error fetching exercises:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchExercises();
  }, [debouncedSearchTerm]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-2xl flex flex-col" style={{ height: '80vh' }}>
        <h2 className="text-2xl font-bold text-white mb-4">Seleccionar Ejercicio</h2>
        
        <div className="relative mb-4">
          <input
            type="text"
            placeholder="Buscar en la biblioteca..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-3 pl-10 bg-gray-700 text-white rounded-lg border-gray-600"
          />
          <IoSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        </div>

        <div className="flex-grow overflow-y-auto">
          {loading ? (
            <p className="text-white text-center">Cargando...</p>
          ) : (
            <ul className="divide-y divide-gray-700">
              {exercises.map(ex => (
                <li 
                  key={ex.id}
                  onClick={() => onSelectExercise(ex)}
                  className="py-3 px-2 flex justify-between items-center cursor-pointer hover:bg-gray-700 rounded"
                >
                  <span className="text-white">{ex.name}</span>
                  <span className="text-sm text-gray-400">{ex.category}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <button onClick={onClose} className="mt-4 bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded-lg">
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ExercisePicker;